export default __webpack_public_path__ + "static/media/HonorBanner.83b89a70.jpg";